import { render } from "./Inventory_Warehouses_Dialog.vue?vue&type=template&id=8bd5597e&scoped=true"
import script from "./Inventory_Warehouses_Dialog.vue?vue&type=script&lang=js"
export * from "./Inventory_Warehouses_Dialog.vue?vue&type=script&lang=js"

import "./Inventory_Warehouses_Dialog.vue?vue&type=style&index=0&id=8bd5597e&scoped=true&lang=css"

import exportComponent from "D:\\Users\\khale\\CookiesBIS\\Core\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8bd5597e"]])

export default __exports__